import { CommonModule, KeyValue }                                               from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule }                        from '@angular/forms';
import { MatCheckboxModule }                                                    from '@angular/material/checkbox';
import { MatFormFieldModule }                                                   from '@angular/material/form-field';
import { MatInputModule }                                                       from '@angular/material/input';
import { MatSelectModule }                                                      from '@angular/material/select';
import { MatTooltipModule }                                                     from '@angular/material/tooltip';
import { UntilDestroy, untilDestroyed }                                         from '@ngneat/until-destroy';
import { LetDirective, PushPipe }                                               from '@ngrx/component';
import { Store }                                                                from '@ngrx/store';
import { Caisse }                                                               from '@shared/classes/caisse';
import { FormuleProductEnum }                                                   from '@shared/constants/formule-product.enum';
import { ESTATE_FORMULE }                                                       from '@shared/enums/ESTATE_FORMULE';
import { FormuleEnum }                                                          from '@shared/enums/formule.enum';
import { includes, stringIsNotNull }                                            from '@shared/helper/LDHelper';
import { NgxMaskDirective, provideNgxMask }                                     from 'ngx-mask';
import { BehaviorSubject, Subject }                                             from 'rxjs';
import { map, withLatestFrom }                                                  from 'rxjs/operators';
import { contractValidators, SEUILS }                                           from 'src/app/components/main/oav-phase-b/preconisation/components/preco-sur-mesure/preco-sur-mesure.constants';
import { DataTarificationPhaseB }                                               from 'src/app/components/main/oav-phase-b/preconisation/dataTarificationPhaseB';
import { CONDITION_SEUIL }                                                      from 'src/app/components/main/oav-phase-b/preconisation/preconisation-oav.constants';
import { ErrorOnFormgroup }                                                     from 'src/app/shared/errors/errorOnFormgroup';
import { selectFormule }                                                        from 'src/app/shared/ngrx/store/selectors/config.selector';
import { selectDatasSurMesurePhaseB, selectDatasTarificationPhaseB }            from 'src/app/shared/ngrx/store/selectors/tarif.selector';
import { ITarificationState }                                                   from 'src/app/shared/ngrx/store/state/tarification/tarification.state';
import { CheckEligiblePipe }                                                    from 'src/app/shared/pipe/checkEligible.pipe';
import { ColorPipe }                                                            from 'src/app/shared/pipe/color.pipe';
import { PricePrecoPipe } from 'src/app/shared/pipe/price-preco.pipe';
import { Form }           from 'src/app/shared/formgroup/form';
import { CellsHeader }    from '../../cells-header';
import { PreconisationOavHelper }                                               from '../../preconisation-oav.helper';
import { AbstractPrecoOavComponent }                                            from '../abstractPreco-oav.component';

@UntilDestroy ()
@Component ({
              selector:        'app-preco-sur-mesure',
              templateUrl:     './preco-sur-mesure.component.html',
              styleUrls:       ['./preco-sur-mesure.component.scss'],
              changeDetection: ChangeDetectionStrategy.OnPush,
              encapsulation:   ViewEncapsulation.Emulated,
              standalone:      true,
              imports: [NgxMaskDirective,
                        CommonModule,
                        MatCheckboxModule,
                        ReactiveFormsModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatSelectModule,
                        MatTooltipModule,
                        ColorPipe,
                        PricePrecoPipe,
                        PushPipe, LetDirective, CheckEligiblePipe],
              providers:       [provideNgxMask ()],
            })
export class PrecoSurMesureComponent extends AbstractPrecoOavComponent implements OnInit {

  public selectDatasSurMesurePhaseB$    = this._store.select (selectDatasSurMesurePhaseB);
  public selectDatasTarificationPhaseB$ = this._store.select (selectDatasTarificationPhaseB);

  @Input ()
  listFormuleSurMesure$: BehaviorSubject<CellsHeader[]>;

  @Input ()
  onError$: Subject<ErrorOnFormgroup>;

  @Input ()
  caisse: Caisse;

  public formule        = FormuleEnum;
  public readOnly$: BehaviorSubject<boolean>;
  public formuleProduct = FormuleProductEnum;
  public seuils: KeyValue<string, string>[];

  private validatorsOfProductsSelected: contractValidators[];

  constructor (protected override _fb: FormBuilder, protected override _store: Store<ITarificationState>) {
    super (_fb, _store);
    this.readOnly$                    = new BehaviorSubject<boolean> (true);
    this.validatorsOfProductsSelected = new Array<contractValidators> ();
  }

  override ngOnInit (): void {
    super.ngOnInit ();
    this.seuils = this.getSeuils ();

    const _self = this;
    _self.formGroup.valueChanges.subscribe ((value) => {
      const errorOnFortmgroup = PreconisationOavHelper.checkErrorOnFormgroup (_self.formGroup.controls, FormuleEnum.SUR_MESURE);
      _self.onError.emit (errorOnFortmgroup);
    });

    this.checkListFormuleSurMesure ();
    this.checkProject ();
    this.checkError ();
  }


  private checkListFormuleSurMesure (): void {
    const _self = this;
    _self.listFormuleSurMesure$.pipe (
      untilDestroyed (this),
      withLatestFrom (
        this._store.select (selectDatasSurMesurePhaseB),
      ),
      map (([cellsHeader, parametersPreconisations]: [CellsHeader[], DataTarificationPhaseB[]]) => {
        cellsHeader.forEach (cellHeader => {
          let value: number | string = '';
          value                      = parametersPreconisations && parametersPreconisations.length > 0 ?
                                       this.getCkParameterByProduct (parametersPreconisations, cellHeader.id) :
                                       '';
          const control              = new FormControl (value, cellHeader.validators);
          this.formGroup.addControl (cellHeader.id, control);

          _self.validatorsOfProductsSelected.push (
            {
              key:        cellHeader.id,
              value,
              validators: cellHeader.validators,
            });
        });
      }),
    ).subscribe ();
  }

  private checkError (): void {
    const _self = this;
    _self.onError$.pipe (
      untilDestroyed (this),
      map (m => {
        this.readOnly$.next (!(m.formule === FormuleEnum.SUR_MESURE));
      }),
    ).subscribe ();
  }

  private checkProject (): void {
    const _self = this;
    _self.checkProject$.pipe (
      untilDestroyed (this),
      map (m => {
        if (![ESTATE_FORMULE.CHECKED].includes(m.check)) {
          Form.reinitValidators (_self.formGroup, m.id);
          Form.reinitError (_self.formGroup, m.id);
        } else {
          const datas = _self.validatorsOfProductsSelected.find (v => v.key === m.id);
          if (!datas) {
            throw new Error (`no validators found for key [${m}]`);
          }
          Form.addValidators (_self.formGroup, datas.key, datas.validators, datas.value);
        }
        _self.formGroup.updateValueAndValidity ({ emitEvent: true });
        console.log (m);
      }),
    ).subscribe ();
  }

  private getSeuils () {
    return SEUILS.filter (c => {
      return CONDITION_SEUIL (c.key, this.caisse);
    });
  }

  onBlur () {
    const c = this.initParametersPreconisation ();
    this.onCheck.emit (c);
  }

  private initParametersPreconisation (): DataTarificationPhaseB {
    const c = new DataTarificationPhaseB ();
    c.check = this.formGroup.get (this.formuleSelected).value;
    c.id    = this.formuleSelected;
    c.mnts  = Object.keys (this.formGroup.controls)
      .filter (k => !includes ([this.formuleSelected, 'HEADER'], k))
      .filter (k => stringIsNotNull (this.formGroup.get (k).value)).map (k => {
        const value = this.formGroup.get (k).value;
        return {
          key: k,
          value,
        };
      });
    return c;
  }

  checkSurMesure (datasTarificationSurMesure: DataTarificationPhaseB[], datasTarificationPhaseB: DataTarificationPhaseB[]) {
    const c = this.initParametersPreconisation ();
    this.onCheck.emit (c);
  }

  getCkParameterByProduct (cs: DataTarificationPhaseB[], f: string): number {
    const v = cs.find (c => c.id == f);
    if (!v) {
      console.error (`key CheckParametersPreconisation not found in list for product [${f}]`);
      return 0;
    }
    return (
      isNaN (v.mnt) || v.mnt == 0 ? 0 : v.mnt
    );
  }

}
